<template>
  <div id="plusPage">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style>
#plusPage{
  height: 100vh;
  background-image: linear-gradient(#4B4847,#342319);
}
</style>